import { render, staticRenderFns } from "./InsElMenu.vue?vue&type=template&id=b53a10fc&scoped=true&"
import script from "./InsElMenu.vue?vue&type=script&lang=ts&"
export * from "./InsElMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53a10fc",
  null
  
)

export default component.exports